import React from 'react';
import { Container } from './styles';
import ReactLoading from 'react-loading';

const Spinner: React.FC = () => {
  return <Container>
    <ReactLoading type={'spinningBubbles'} color={'#f37021'} height={64} width={64} />
  </Container>
};

export default Spinner;


//------------------- types
// blank
// balls
// bars
// bubbles
// cubes
// cylon
// spin
// spinningBubbles
// spokes
